module.exports = __webpack_public_path__ + "static/media/hamburger-menu.f9c31f83.svg";